import Image_GK_stops_map from "./GK-stops-map.jpg";

const MULTIMEDIA = [
  {
    title:
      "Interactive map: Where do Great Knots stop during migration?",
    text:
      "Check out the stopping sites of Great Knots and the knowledge gaps in the East Asian-Australiasian Flyway!",
    image: Image_GK_stops_map,
    url: "https://chanyingchi.github.io/greatknot.stops/",
  },
  {
    title:
      "Video: Migration of Great Knots",
    text: <span>In 2015-2017, a team of scientists from the Netherlands (University of Groningen and NIOZ), USA (US Geological Survey) and Australia, brought together by the Global Flyway Network, tracked Great Knots (<i>Calidris tenuirostris</i>) year-round with satellite transmitters. This is the first time that the entire migration journey of this Endangered species has been tracked. Watch the video to see the tracks of some individuals in 2016 and the habitats they were at!</span>,
    youtube: "2Ihi_On9u4w",
  },
];

export default MULTIMEDIA;
